<template>
	<div class="login-bar">
  		<div v-if="loginUser">[{{loginUser.name}}] &nbsp;
  			<a @click="logout" href="javascript:void(0);">安全退出</a>
  		</div>
  		<div v-else>
  			<a @click="showLogin" href="javascript:void(0);">登录</a> 或 
  			<a @click="showRegister" href="javascript:void(0);">注册</a>
  		</div>
  		<!--登录-->
  		<div class="panel panel-login" v-if="showPanelLogin">
  			<h3 class="panel-title">登录<span class="panel-close" @click="closePanel">×</span></h3>
  			<div>
  				<label>用户名：</label>
  				<div class="div-input">
  					<input name="login_name" id="login_name" type="text" class="panel-input" maxlength="20" placeholder="请输入姓名" v-model="login_name">
  				</div>  				
  				<span class="panel-tips">4-20个字符,由字母数字下划线组成</span>
  			</div>
  			<div>
  				<label>密&nbsp;&nbsp;&nbsp;&nbsp;码：</label>
  				<div class="div-input">
  					<input name="login_pwd" id="login_pwd" type="password" class="panel-input" maxlength="16" placeholder="请输入密码" v-model="login_pass">
  				</div>
  				<span class="panel-tips">6-16个字符,区分大小写</span>
  			</div>
  			<button @click="checkLoginForm" class="panel-btn">登 录</button>
  		</div>
  		<!--注册-->
  		<div class="panel panel-register" v-if="showPanelRegister">
  			<h3 class="panel-title">注册<span class="panel-close" @click="closePanel">×</span></h3>
  			<div class="div-item">
  				<label>用&nbsp;户&nbsp;名：</label>
  				<div class="div-input">
  					<input name="reg_name" id="reg_name" type="text" class="panel-input" maxlength="20" placeholder="请输入姓名" v-model="reg_name">
  				</div>  				
  				<span class="panel-tips">4-20个字符,由字母数字下划线组成</span>
  			</div>
  			<div class="div-item">
  				<label>密&nbsp;&nbsp;&nbsp;&nbsp;码：</label>
  				<div class="div-input">
  					<input name="reg_pwd" id="reg_pwd" type="password" class="panel-input" maxlength="16" placeholder="请输入密码" v-model="reg_pass">
  				</div>
  				<span class="panel-tips">6-16个字符,区分大小写</span>
  			</div>
  			<div class="div-item">
  				<label>确认密码：</label>
  				<div class="div-input">
  					<input name="reg_pwd2" id="reg_pwd2" type="password" class="panel-input" maxlength="16" placeholder="请输入确认密码" v-model="reg_pass2">
  				</div>
  			</div>
  			<div class="div-item">
  				<label>电子邮箱：</label>
  				<div class="div-input">
  					<input name="reg_email" id="reg_email" type="text" class="panel-input" maxlength="50" placeholder="请输入电子邮箱" v-model="reg_email">
  				</div>
  			</div>
  			<div class="center"><span>根据文化部《网络有管理暂行办法》规定，网络游戏用户须使用有效身份证件进行实名注册</span></div>
  			<div class="div-item">
  				<label>真实姓名：</label>
  				<div class="div-input">
  					<input name="reg_realName" id="reg_realName" type="text" class="panel-input" maxlength="20" placeholder="请输入真实姓名" v-model="reg_realname">
  				</div>
  			</div>
  			<div class="div-item">
  				<label>身份证号：</label>
  				<div class="div-input">
  					<input name="reg_id" id="reg_id" type="text" class="panel-input" maxlength="18" placeholder="请输入身份证号码" v-model="reg_idnum">
  				</div>
  			</div>
  			<div class="div-item">
  				<label>手机号码：</label>
  				<div class="div-input">
  					<input name="reg_phone" id="reg_phone" type="text" class="panel-input" maxlength="11" placeholder="请输入手机号码" v-model="reg_phone">
  				</div>
  			</div>
  			<div class="div-checkbox center">
  				<input name="reg_checkbox" id="reg_checkbox" type="checkbox" class="panel-checkbox" v-model="reg_readed">
  				<span>&nbsp;我已阅读并同意
	  				<router-link to="/protocol" target="_blank">
	  					<b style="color:red">《{{GLOBAL.short_name}}用户注册协议》</b>
	  				</router-link>
  				</span>
  			</div>
  			<button @click="checkRegisterForm" class="panel-btn">注 册</button>
  		</div>
  		<!--蒙层-->
  		<div class="panel-mask" v-if="showPanelLogin || showPanelRegister" @click="closePanel"></div>
	</div>
</template>

<script>
export default {
  data () {
    return {
    	loginUser:null,
    	showPanelLogin:false,
    	showPanelRegister:false,
    	login_name:"",
    	login_pass:"",
    	reg_name:"",
    	reg_pass:"",
    	reg_pass2:"",
    	reg_email:"",
    	reg_realname:"",
    	reg_idnum:"",
    	reg_phone:"",
    	reg_readed:false
    }
  },
  mounted(){
  	//this.cookie('uName','hahaha',{ expires: 30 });
  	console.log(this.cookie('uName'));
  },
  methods:{
  	//MD5
	md5:function(string,key,raw){function safe_add(x,y){var lsw=(x&65535)+(y&65535),msw=(x>>16)+(y>>16)+(lsw>>16);return(msw<<16)|(lsw&65535)}function bit_rol(num,cnt){return(num<<cnt)|(num>>>(32-cnt))}function md5_cmn(q,a,b,x,s,t){return safe_add(bit_rol(safe_add(safe_add(a,q),safe_add(x,t)),s),b)}function md5_ff(a,b,c,d,x,s,t){return md5_cmn((b&c)|((~b)&d),a,b,x,s,t)}function md5_gg(a,b,c,d,x,s,t){return md5_cmn((b&d)|(c&(~d)),a,b,x,s,t)}function md5_hh(a,b,c,d,x,s,t){return md5_cmn(b^c^d,a,b,x,s,t)}function md5_ii(a,b,c,d,x,s,t){return md5_cmn(c^(b|(~d)),a,b,x,s,t)}function binl_md5(x,len){x[len>>5]|=128<<(len%32);x[(((len+64)>>>9)<<4)+14]=len;var i,olda,oldb,oldc,oldd,a=1732584193,b=-271733879,c=-1732584194,d=271733878;for(i=0;i<x.length;i+=16){olda=a;oldb=b;oldc=c;oldd=d;a=md5_ff(a,b,c,d,x[i],7,-680876936);d=md5_ff(d,a,b,c,x[i+1],12,-389564586);c=md5_ff(c,d,a,b,x[i+2],17,606105819);b=md5_ff(b,c,d,a,x[i+3],22,-1044525330);a=md5_ff(a,b,c,d,x[i+4],7,-176418897);d=md5_ff(d,a,b,c,x[i+5],12,1200080426);c=md5_ff(c,d,a,b,x[i+6],17,-1473231341);b=md5_ff(b,c,d,a,x[i+7],22,-45705983);a=md5_ff(a,b,c,d,x[i+8],7,1770035416);d=md5_ff(d,a,b,c,x[i+9],12,-1958414417);c=md5_ff(c,d,a,b,x[i+10],17,-42063);b=md5_ff(b,c,d,a,x[i+11],22,-1990404162);a=md5_ff(a,b,c,d,x[i+12],7,1804603682);d=md5_ff(d,a,b,c,x[i+13],12,-40341101);c=md5_ff(c,d,a,b,x[i+14],17,-1502002290);b=md5_ff(b,c,d,a,x[i+15],22,1236535329);a=md5_gg(a,b,c,d,x[i+1],5,-165796510);d=md5_gg(d,a,b,c,x[i+6],9,-1069501632);c=md5_gg(c,d,a,b,x[i+11],14,643717713);b=md5_gg(b,c,d,a,x[i],20,-373897302);a=md5_gg(a,b,c,d,x[i+5],5,-701558691);d=md5_gg(d,a,b,c,x[i+10],9,38016083);c=md5_gg(c,d,a,b,x[i+15],14,-660478335);b=md5_gg(b,c,d,a,x[i+4],20,-405537848);a=md5_gg(a,b,c,d,x[i+9],5,568446438);d=md5_gg(d,a,b,c,x[i+14],9,-1019803690);c=md5_gg(c,d,a,b,x[i+3],14,-187363961);b=md5_gg(b,c,d,a,x[i+8],20,1163531501);a=md5_gg(a,b,c,d,x[i+13],5,-1444681467);d=md5_gg(d,a,b,c,x[i+2],9,-51403784);c=md5_gg(c,d,a,b,x[i+7],14,1735328473);b=md5_gg(b,c,d,a,x[i+12],20,-1926607734);a=md5_hh(a,b,c,d,x[i+5],4,-378558);d=md5_hh(d,a,b,c,x[i+8],11,-2022574463);c=md5_hh(c,d,a,b,x[i+11],16,1839030562);b=md5_hh(b,c,d,a,x[i+14],23,-35309556);a=md5_hh(a,b,c,d,x[i+1],4,-1530992060);d=md5_hh(d,a,b,c,x[i+4],11,1272893353);c=md5_hh(c,d,a,b,x[i+7],16,-155497632);b=md5_hh(b,c,d,a,x[i+10],23,-1094730640);a=md5_hh(a,b,c,d,x[i+13],4,681279174);d=md5_hh(d,a,b,c,x[i],11,-358537222);c=md5_hh(c,d,a,b,x[i+3],16,-722521979);b=md5_hh(b,c,d,a,x[i+6],23,76029189);a=md5_hh(a,b,c,d,x[i+9],4,-640364487);d=md5_hh(d,a,b,c,x[i+12],11,-421815835);c=md5_hh(c,d,a,b,x[i+15],16,530742520);b=md5_hh(b,c,d,a,x[i+2],23,-995338651);a=md5_ii(a,b,c,d,x[i],6,-198630844);d=md5_ii(d,a,b,c,x[i+7],10,1126891415);c=md5_ii(c,d,a,b,x[i+14],15,-1416354905);b=md5_ii(b,c,d,a,x[i+5],21,-57434055);a=md5_ii(a,b,c,d,x[i+12],6,1700485571);d=md5_ii(d,a,b,c,x[i+3],10,-1894986606);c=md5_ii(c,d,a,b,x[i+10],15,-1051523);b=md5_ii(b,c,d,a,x[i+1],21,-2054922799);a=md5_ii(a,b,c,d,x[i+8],6,1873313359);d=md5_ii(d,a,b,c,x[i+15],10,-30611744);c=md5_ii(c,d,a,b,x[i+6],15,-1560198380);b=md5_ii(b,c,d,a,x[i+13],21,1309151649);a=md5_ii(a,b,c,d,x[i+4],6,-145523070);d=md5_ii(d,a,b,c,x[i+11],10,-1120210379);c=md5_ii(c,d,a,b,x[i+2],15,718787259);b=md5_ii(b,c,d,a,x[i+9],21,-343485551);a=safe_add(a,olda);b=safe_add(b,oldb);c=safe_add(c,oldc);d=safe_add(d,oldd)}return[a,b,c,d]}function binl2rstr(input){var i,output="";for(i=0;i<input.length*32;i+=8){output+=String.fromCharCode((input[i>>5]>>>(i%32))&255)}return output}function rstr2binl(input){var i,output=[];output[(input.length>>2)-1]=undefined;for(i=0;i<output.length;i+=1){output[i]=0}for(i=0;i<input.length*8;i+=8){output[i>>5]|=(input.charCodeAt(i/8)&255)<<(i%32)}return output}function rstr_md5(s){return binl2rstr(binl_md5(rstr2binl(s),s.length*8))}function rstr_hmac_md5(key,data){var i,bkey=rstr2binl(key),ipad=[],opad=[],hash;ipad[15]=opad[15]=undefined;if(bkey.length>16){bkey=binl_md5(bkey,key.length*8)}for(i=0;i<16;i+=1){ipad[i]=bkey[i]^909522486;opad[i]=bkey[i]^1549556828}hash=binl_md5(ipad.concat(rstr2binl(data)),512+data.length*8);return binl2rstr(binl_md5(opad.concat(hash),512+128))}function rstr2hex(input){var hex_tab="0123456789abcdef",output="",x,i;for(i=0;i<input.length;i+=1){x=input.charCodeAt(i);output+=hex_tab.charAt((x>>>4)&15)+hex_tab.charAt(x&15)}return output}function str2rstr_utf8(input){return unescape(encodeURIComponent(input))}function raw_md5(s){return rstr_md5(str2rstr_utf8(s))}function hex_md5(s){return rstr2hex(raw_md5(s))}function raw_hmac_md5(k,d){return rstr_hmac_md5(str2rstr_utf8(k),str2rstr_utf8(d))}function hex_hmac_md5(k,d){return rstr2hex(raw_hmac_md5(k,d))}if(!key){if(!raw){return hex_md5(string)}return raw_md5(string)}if(!raw){return hex_hmac_md5(key,string)}return raw_hmac_md5(key,string)},	
	
  	showLogin:function(){
  		this.showPanelLogin=true;
  	},
  	showRegister:function(){
  		this.showPanelRegister=true;
  	},
  	reg:function(uName,pwd) {
		this.cookie(this.md5(uName),this.md5(pwd),{ expires: 30 });
		this.cookie('uName',uName,{ expires: 7 });
		this.loginUser={name:uName};
  		this.reg_name="";
    	this.reg_pass="";
    	this.reg_pass2="";
    	this.reg_email="";
    	this.reg_realname="";
    	this.reg_idnum="";
    	this.reg_phone="";
    	this.reg_readed=false;
	},
  	logout:function(){
  		this.cookie('uName', '', { expires: -1 });
  		this.loginUser=null;
  	},
  	login:function(uName,pwd){
  		var cp = this.cookie(this.md5(uName));
		if (cp && this.md5(pwd) == cp) {
			this.cookie('uName',uName,{ expires: 7 });
			this.loginUser={name:uName};
			alert('您已成功登录成功!');
			this.closePanel();
			return;
		}
		alert('您的用户名密码不正确,请重新输入.');
  	},
  	checkLoginForm:function(){
  		console.log("===== login");
  		this.login(this.login_name,this.login_pass);
  	},
  	checkRegisterForm:function(){
  		console.log("===== reg");
  		if (!this.reg_name || !this.reg_name.match(/^[0-9a-zA-Z_\-]{4,20}$/)) {
		    alert('请输入正确格式的用户名:4-20个字符,由字母数字下划线组成.');
		    return;
		}
		if (!this.reg_pass || !this.reg_pass2 || this.reg_pass.length < 6) {
		    alert('请正确输入密码,至少6位字符');
		    return;
		}
		if (this.reg_pass != this.reg_pass2) {
		    alert('两次输入的密码不相同,请重新输入');
		    return;
		}
		if (!this.reg_email || !this.emailCheck(this.reg_email)) {
		    alert('邮箱格式有误,请重新输入');
		    return;
		}
		if (!this.reg_realname || !this.cnNameCheck(this.reg_realname)) {
		    alert('您输入的姓名有误!');
		    return;
		}
		if (this.reg_realname.length < 2 || this.reg_realname.length > 10) {
		    alert('您输入的姓名有误!');
		    return;
		}
		if (!this.checkbjx(this.reg_realname[0])) {
		    alert('您输入的姓名有误!');
		    return;
		}
		if (!this.reg_idnum) {
		    alert('请输入身份证号.');
		    return;
		}
		var idRe = this.checkIdcard(this.reg_idnum);
		if (idRe != 0) {
		    alert(idRe);
		    return;
		}
		if (!this.reg_phone) {
		    alert('请输入手机号码.');
		    return;
		}
		if (!this.checkPhone(this.reg_phone)) {
		    alert('输入手机号码有误');
		    return;
		}
		if (!this.reg_readed) {
		    alert('请确认并同意协议.');
		    return;
		}
		this.reg(this.reg_name, this.reg_pass);
		alert('注册成功!');
		this.closePanel();
  	},
  	checkbjx:function(name) {
	    var lastname="赵|钱|孙|李|周|吴|郑|王|冯|陈|楮|卫|蒋|沈|韩|杨|朱|秦|尤|许|何|吕|施|张|孔|曹|严|华|金|魏|陶|姜|戚|谢|邹|喻|柏|水|窦|章|云|苏|潘|葛|奚|范|彭|郎|鲁|韦|昌|马|苗|凤|花|方|俞|任|袁|柳|酆|鲍|史|唐|费|廉|岑|薛|雷|贺|倪|汤|滕|殷|罗|毕|郝|邬|安|常|乐|于|时|傅|皮|卞|齐|康|伍|余|元|卜|顾|孟|平|黄|和|穆|萧|尹|姚|邵|湛|汪|祁|毛|禹|狄|米|贝|明|臧|计|伏|成|戴|谈|宋|茅|庞|熊|纪|舒|屈|项|祝|董|梁|杜|阮|蓝|闽|席|季|麻|强|贾|路|娄|危|江|童|颜|郭|梅|盛|林|刁|锺|徐|丘|骆|高|夏|蔡|田|樊|胡|凌|霍|虞|万|支|柯|昝|管|卢|莫|经|房|裘|缪|干|解|应|宗|丁|宣|贲|邓|郁|单|杭|洪|包|诸|左|石|崔|吉|钮|龚|程|嵇|邢|滑|裴|陆|荣|翁|荀|羊|於|惠|甄|麹|家|封|芮|羿|储|靳|汲|邴|糜|松|井|段|富|巫|乌|焦|巴|弓|牧|隗|山|谷|车|侯|宓|蓬|全|郗|班|仰|秋|仲|伊|宫|宁|仇|栾|暴|甘|斜|厉|戎|祖|武|符|刘|景|詹|束|龙|叶|幸|司|韶|郜|黎|蓟|薄|印|宿|白|怀|蒲|邰|从|鄂|索|咸|籍|赖|卓|蔺|屠|蒙|池|乔|阴|郁|胥|能|苍|双|闻|莘|党|翟|谭|贡|劳|逄|姬|申|扶|堵|冉|宰|郦|雍|郤|璩|桑|桂|濮|牛|寿|通|边|扈|燕|冀|郏|浦|尚|农|温|别|庄|晏|柴|瞿|阎|充|慕|连|茹|习|宦|艾|鱼|容|向|古|易|慎|戈|廖|庾|终|暨|居|衡|步|都|耿|满|弘|匡|国|文|寇|广|禄|阙|东|欧|殳|沃|利|蔚|越|夔|隆|师|巩|厍|聂|晁|勾|敖|融|冷|訾|辛|阚|那|简|饶|空|曾|毋|沙|乜|养|鞠|须|丰|巢|关|蒯|相|查|后|荆|红|游|竺|权|逑|盖|益|桓|公|万俟|司马|上官|欧阳|夏侯|诸葛|闻人|东方|赫连|皇甫|尉迟|公羊|澹台|公冶|宗政|濮阳|淳于|单于|太叔|申屠|公孙|仲孙|轩辕|令狐|锺离|宇文|长孙|慕容|鲜于|闾丘|司徒|司空|丌官|司寇|仉|督|子车|颛孙|端木|巫马|公西|漆雕|乐正|壤驷|公良|拓拔|夹谷|宰父|谷梁|晋|楚|阎|法|汝|鄢|涂|钦|段干|百里|东郭|南门|呼延|归|海|羊舌|微生|岳|帅|缑|亢|况|后|有|琴|梁丘|左丘|东门|西门|商|牟|佘|佴|伯|赏|南宫|墨|哈|谯|笪|年|爱|阳|佟|第五|言|福";
	    if (lastname.search(name) != -1) {
	        return true;
	    } else {
	        return false;
	    }
	},
	emailCheck:function(str) {
	    var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
	    var flag = reg.test(str);
	    return flag;
	},
	
	checkPhone:function(str) {
	    var reg = /^[1][0-9]{10}$/;
	    var flag = reg.test(str);
	    return flag;
	},
	
	cnNameCheck:function(str) {
	    if (!str) {
	        return false;
	    }
	    if (str.length < 2 || str.length > 5) {
	        return false;
	    }
	    var reg = /^[\u4e00-\u9fa5](\s*[\u4e00-\u9fa5])*$/;
	    var flag = reg.test(str);
	    return flag;
	},
	
	checkIdcard:function(idcard) {
	    var Errors = new Array(0, "您输入的身份证号码有误!", "您输入的身份证号码有误!", "您输入的身份证号码有误!", "您输入的身份证号码有误!");
	    var area = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
	    var idcard, Y, JYM, ereg;
	    var S, M;
	    var idcard_array = new Array();
	    idcard_array = idcard.split("");
	    if (area[parseInt(idcard.substr(0, 2))] == null) return Errors[4];
	    switch (idcard.length) {
	        case 15:
	            if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || ((parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0)) {
	                ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
	            } else {
	                ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
	            }
	            if (ereg.test(idcard)) return Errors[0];
	            else return Errors[2];
	            break;
	        case 18:
	            if (parseInt(idcard.substr(6, 4)) % 4 == 0 || (parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0)) {
	                ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
	            } else {
	                ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
	            }
	            if (ereg.test(idcard)) {
	                S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
	                Y = S % 11;
	                M = "F";
	                JYM = "10X98765432";
	                M = JYM.substr(Y, 1);
	                if (M == idcard_array[17]) return Errors[0];
	                else return Errors[3];
	            } else return Errors[2];
	            break;
	        default:
	            return Errors[1];
	            break;
	    }
	},
  	closePanel:function(){
  		this.showPanelLogin=false;
  		this.showPanelRegister=false;
  		this.login_name="";
  		this.login_pass="";
  	},
  	cookie: function(key, value, options) {
	    if (value !== undefined) {
	        options = JSON.parse(JSON.stringify(options));
	        if (typeof options.expires === 'number') {
	            var days = options.expires,
	                t = options.expires = new Date();
	            t.setTime(+t + days * 864e+5);
	        };
	        return (document.cookie = [
	            encodeURIComponent(key), '=', encodeURIComponent(String(value)),
	            options.expires ? '; expires=' + options.expires.toUTCString() : '',
	            options.path ? '; path=' + options.path : '',
	            options.domain ? '; domain=' + options.domain : '',
	            options.secure ? '; secure' : ''
	        ].join(''));
	    };
	    var result = key ? undefined : {};
	    var cookies = document.cookie ? document.cookie.split('; ') : [];
	    for (var i = 0, l = cookies.length; i < l; i++) {
	        var parts = cookies[i].split('=');
	        var name = decodeURIComponent(parts.shift());
	        var cookie = parts.join('=');
	        if (key && key === name) {
	            result = this.parseCookieValue(cookie);
	            break;
	        };
	        if (!key && (cookie = this.parseCookieValue(cookie)) !== undefined) {
	            result[name] = cookie;
	        };
	    };
	    return result;
	},
	parseCookieValue: function(s) {
	    if (s.indexOf('"') === 0) s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
	    try {
	    	var pluses = /\+/g;
	        s = decodeURIComponent(s.replace(pluses, ' '));
	        return s;
	    } catch (e) {}
	}
  }
}
</script>

<style scoped>
	.login-bar{
		display:inline-block;
		position:absolute;
		top:0;
		right:0;
		padding:35px 15px 0 10px;
		z-index:3;
	}
	.login-bar{font-size:14px;line-height:1.4;color:#999;}
	.login-bar a{color:#3366FF;cursor:pointer;}
	.login-bar a:hover{color:#1e78eb;}
	
	.panel-mask{z-index:50;width:100%;height:100%;position:fixed;top:0;left:0;background:rgba(0,0,0,.6);opacity:.6;}
	.panel{z-index:51;position:fixed;background:#FFF;border-radius:5px;box-shadow: 0 1px 5px rgba(0,0,0,.5);}
	.panel-login{top:30%;left:50%;width:320px;margin-left:-160px;height:auto;}
	.panel-register{top:0;left:50%;width:700px;margin-left:-350px;height:auto;max-height:100%;overflow-y:auto;}
	.panel div.center{text-align:center;}
	.panel .panel-title{text-align:left;padding:10px 15px;color:#FFF;font-size:20px;font-weight:400;line-height:1.4;letter-spacing:10px;background:#1e78eb;border-radius:5px 5px 0 0;position:relative;display:block;}
	.panel .panel-close{position:absolute;right:0;top:0;font-size:20px;line-height:20px;letter-spacing:0;color:#FFF;display:inline-block;padding:10px;cursor:pointer;font-family:"Microsoft YaHei","微软雅黑",arial,simsun,"宋体";}
	.panel > div{position:relative;display:block;margin:15px 20px;text-align:left;}
	.panel > div > label{width:70px;float:left;line-height:30px;}
	.panel .div-input{margin-left:71px;width:60%;}
	.panel .panel-checkbox{height:20px;width:20px;}
	.panel .div-checkbox{vertical-align: top;}
	.panel .div-checkbox *{vertical-align: top;}
	.panel .div-input .panel-input{width:100%;padding:5px 0;text-indent:10px;line-height:20px;font-size:14px;color:#666;border:1px solid #999;border-radius:5px;outline:none;}
	.panel .panel-tips{margin-left:71px;display:block;text-align:left;font-size:12px;color:#999;line-height:1.5;}
	.panel .panel-btn{background:#1e78eb;padding:10px 50px;font-size:18px;line-height:1.5;color:#FFF;outline:none;border:none;border-radius:8px;margin:10px auto 20px;}
	.panel.panel-register > div{margin:10px 50px;}
	.panel.panel-register .div-item{max-width:425px;margin:15px auto;}
@media screen and (max-width:768px) {
	.panel-register{top:0;left:50%;width:320px;margin-left:-160px;max-height:100%;}
	.panel.panel-register > div{margin:5px 15px;}
	.panel.panel-register .div-item{margin:5px 15px;}
	.panel .div-checkbox{font-size:13px;padding:10px 0;}
	.panel .div-input{width:auto;}
}
</style>


// WEBPACK FOOTER //
// src/components/loginbar.vue